import { Button, Radio, Select, Table, Input } from "antd";
import React, { useEffect, useState } from "react";
import apiClient from "../../../utils/apiClient";
import useUser from "../../../hooks/useUser";
import useToast from "../../../hooks/userToast";
import PropTypes from "prop-types";
import { Option } from "antd/es/mentions";

AssignQualityChecker.propTypes = {
  studyPrimaryKey: PropTypes.number,
  handleOk: PropTypes.func,
  fetchData: PropTypes.func,
};

function AssignQualityChecker({ studyPrimaryKey, handleOk, fetchData }) {
  const [selectedQC, setSelectedQC] = useState(null);
  const [QCData, setQCData] = useState([]);
  const [filteredQCData, setFilteredQCData] = useState([]); // State for filtered data
  const { userID } = useUser();
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // State for search term

  const { toastError } = useToast();

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const formData = {
        study_info_model_id: studyPrimaryKey,
        role_quality_checker: selectedQC,
        role_sub_admin: userID,
        status: "read",
      };
      await apiClient.post("auth/create-study-status", formData);
      await handleOk();
      // toastSuccess("Assigned Quality Checker Successfully");
      await fetchData();
    } catch (error) {
      toastError(error);
    } finally {
      setLoading(false);
    }
  };

  const getAllQC = async () => {
    try {
      const categoryParam =
        selectedCategory === "all" ? "" : `&categoryId=${selectedCategory}`;
      const response = await apiClient.get(
        `/users?role=qualitychecker&limit=1000${categoryParam}`
      );
      setQCData(response?.data?.users?.data);
      setFilteredQCData(response?.data?.users?.data); // Set initial filtered data
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllQC();
  }, [selectedCategory]);

  const columns = [
    {
      title: "Quality Checker Name",
      dataIndex: "name",
      key: "id",
      width: 100,
      render: (text, record) => (
        <div className="d-flex justify-content-between align-items-center">
          <div>{record.name}</div>
          <Radio
            checked={selectedQC === record?.id}
            style={{ marginLeft: "20px" }}
            onChange={() => setSelectedQC(record?.id)}
          />
        </div>
      ),
    },
  ];

  const fetchCategories = async () => {
    try {
      const response = await apiClient.get(`/category`);
      setCategories(response?.data?.category?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleCategoryChange = (value) => {
    setSelectedCategory(value);
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    setFilteredQCData(
      QCData?.filter((qc) => qc.name.toLowerCase().includes(value))
    );
  };

  return (
    <>
      <div
        style={{
          marginLeft: "20px",
          marginBottom: "0px",
          width: "75%",
          display: "flex",
          justifyContent: "space-around",
        }}
      >
        <Select
          style={{ width: "220px", height: "39px", marginLeft: "20px" }}
          showSearch
          placeholder="Select Category"
          value={selectedCategory || "all"}
          onChange={handleCategoryChange}
        >
          <Option value="all">All</Option>
          {categories?.map((element) => (
            <Option key={element?.id} value={element?.id}>
              {element?.name}
            </Option>
          ))}
        </Select>

        <div
          style={{
            marginLeft: "20px",
            marginBottom: "0px",
            width: "250px",
            display: "flex",
            justifyContent: "space-around",
          }}
        >
          <Input
            placeholder="Search Quality Checker by Name"
            value={searchTerm}
            onChange={handleSearch}
            style={{ width: "300px" }}
          />
        </div>
      </div>

      <div style={{ overflow: "auto", height: "350px" }}>
        <Table
          dataSource={filteredQCData}
          columns={columns}
          pagination={false}
        />
      </div>

      <div className="d-flex justify-content-end my-2">
        <Button
          className="btn btn-primary"
          type="button"
          disabled={loading}
          loading={loading}
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </div>
    </>
  );
}

export default AssignQualityChecker;
